//
//
//
//
//
//

export default {
  computed: {
    isClubActivityPage() {
      return this.$route.path.includes('promociones/club-bet-777/actividad')
    }
  }
}
